<script>
    // Import modals
    import ModalActivateUser from './modals/ActivateUser.vue';
    import ModalDeactivateUser from './modals/DeactivateUser.vue';
    import ModalEditUser from './modals/EditUser.vue';
    import ModalResetPassword from './modals/ResetPassword.vue';

    export default {
        components: {
            ModalActivateUser,
            ModalDeactivateUser,
            ModalEditUser,
            ModalResetPassword,
        },
        props: {
            user: Object,
        },
        methods: {
            openDropdown() {
                this.$refs.dropdown.classList.toggle('is-active');
                document.addEventListener('click', (event) => {
                    if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                        this.$refs.dropdown.classList.remove('is-active');
                    }
                });
            },
            openModal(modalName, props = {}) {
                if (!modalName) return;
                const component = this.$options.components[modalName];

                if (component) {
                    this.$store.commit('openModal',
                        {
                            component: component,
                            props: props,
                        }
                    );
                }
            },
        },
    }
</script>

<template>
    <div class="dropdown is-right" ref="dropdown">
        <div class="dropdown-trigger" @click="openDropdown">
            <button class="button is-small p-1" aria-haspopup="true" aria-controls="dropdown-menu">
                <i class="fa-solid fa-angle-down" aria-hidden="true"></i>
            </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
            <div class="dropdown-content">
                <a v-if="user.active" @click="openModal('ModalDeactivateUser', { id: user.id })" class="dropdown-item">
                    {{ $store.getters.getUserManagementText('usermanagementModalButtonDeactivate') }}
                </a>
                <a v-else @click="openModal('ModalActivateUser', { id: user.id })" class="dropdown-item">
                    {{ $store.getters.getUserManagementText('usermanagementModalButtonActivate') }}
                </a>
                <a @click="openModal('ModalEditUser', { user: user })" class="dropdown-item">
                    {{ $store.getters.getUserManagementText('usermanagementModalTitleEdit') }}
                </a>
                <a v-if="user.active" @click="openModal('ModalResetPassword', { username: user.username })" class="dropdown-item">
                    {{ $store.getters.getUserManagementText('usermanagementModalButtonPwreset') }}
                </a>
            </div>
        </div>
    </div>
</template>
